<template>
  <v-layout row wrap justify-center>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-flex
          xs12
          class="text-xs-left text-sm-center text-md-center text-lg-center"
        >
          <v-card-title class="title d-inline-block">
            {{ lang.secret_word_necessary }}
          </v-card-title>
        </v-flex>
        <v-card-text
          :class="{
            'px-4': $vuetify.breakpoint.smAndUp,
            'px-3': $vuetify.breakpoint.xsOnly
          }"
        >
          <v-layout row wrap justify-center>
            <v-flex xs12 sm8 class="pb-2">
              <span class="title">{{ lang.secret_word }}</span>
            </v-flex>
            <v-flex
              xs12
              sm8
              :class="{ 'd-inline-flex': $vuetify.breakpoint.smAndUp }"
            >
              <v-text-field
                type="password"
                background-color="amber lighten-4"
                @keyup.enter="validateSecretWord"
                v-model="secretWord"
                solo
                v-validate="'required'"
                data-vv-name="secretWordValidation"
                :error-messages="errors.collect('secretWordValidation')"
                :autofocus="true"
                required
              ></v-text-field>
              <v-btn
                :class="{ 'mx-0': $vuetify.breakpoint.xsOnly }"
                :style="{ 'text-transform': 'none', 'max-width': '130px' }"
                @click="validateSecretWord"
                :loading="isLoading"
                :disabled="isLoading || errors.has('secretWordValidation')"
              >
                {{ lang.confirmation }}
              </v-btn>
              <v-btn
                :class="{ 'mx-0': $vuetify.breakpoint.xsOnly }"
                :style="{ 'text-transform': 'none', 'max-width': '130px' }"
                @click="cancel"
                :loading="isLoading"
                :disabled="isLoading || errors.has('secretWordValidation')"
              >
                {{ lang.cancel }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "vc-share-wall-contents-password-input-form",
  data() {
    return {
      dialog: false,
      isLoading: false,
      identificationCode: "",
      positionIndex: "",
      secretWord: "",
      dictionary: {
        custom: {
          secretWordValidation: {}
        }
      }
    };
  },
  props: {
    code: {
      type: String,
      default: ""
    },
    wallViewerUrl: {
      type: String,
      default: ""
    },
    lang: {
      Type: Object,
      default: () => {
        return {
          secret_word_necessary:
            "この作品を閲覧するには、「合言葉」が必要です。",
          secret_word: "合言葉",
          confirmation: "確認",
          cancel: "キャンセル",
          error_password_mismatch: "合言葉が違います。"
        };
      }
    },
    contentsInfoApiUrlBase: {
      type: String,
      default: ""
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: ""
        };
      }
    },
    localeCode: {
      type: String,
      default: ""
    },
    postContentsSecretWord: {
      type: Function,
      default: () => {}
    }
  },
  mounted: function() {
    // 翻訳文言を設定
    this.dictionary.custom.secretWordValidation.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.secret_word
    );
    this.$validator.localize(this.localeCode, this.dictionary);

    // onMessage用イベントリスナを設定
    const thisObj = this;
    window.addEventListener("message", function(event) {
      if (event.data.event === "requiresSecretWord") {
        thisObj.identificationCode = event.data.identification_code;
        thisObj.positionIndex = event.data.position_index;
        thisObj.dialog = true;
      }
    });
  },
  methods: {
    validateSecretWord: function() {
      this.$validator.validate().then(result => {
        if (!result) {
          return;
        }

        this.isLoading = true;

        let requestData = {
          code: this.identificationCode,
          secretWord: this.secretWord
        };

        const contentsInfoApiUrl =
          JSON.parse(this.contentsInfoApiUrlBase) + this.identificationCode;

        this.postContentsSecretWord(requestData).then(value => {
          // 認証に成功
          if (value === 0) {
            // ビューアにpostMessageする
            const postMessageBody = {
              event: "correctSecretWord",
              position_index: this.positionIndex,
              contents_info_api_url: contentsInfoApiUrl
            };

            const embeddedViewerIframeElement = document.querySelector(
              "[data-embeded-viewer]"
            ).contentWindow;

            embeddedViewerIframeElement.postMessage(
              postMessageBody,
              this.wallViewerUrl
            );
            this.dialog = false;
          }
          this.isLoading = false;
        });
      });
    },
    cancel: function() {
      this.dialog = false;
    }
  }
};
</script>
